
import { InfoCircleOutlined } from "@ant-design/icons";
import { Button, Checkbox, DatePicker, Form, Image, Input, Layout, message, notification, Radio, Select, Typography } from "antd";
import { useEffect, useState } from "react";
import AboutUsModal from '../AboutUs';
import { api_companies, api_get_employee_type, api_get_from_addrs, api_ll_requested, api_policy_type, api_practice_states } from '../api/info';
import { api_quota_inquery } from '../api/quota_inquery';
import '../App.css';
import { API_URL, InqueryRequest, PracticeState } from '../constant';
import HeaderComponent from "../component/header";

const { Option } = Select;
const { Title } = Typography;
const { Link } = Typography;
const { Header } = Layout;

const practiceItems = {
  "acupuncture": "Acupuncture",
  "adjustments": "Adjustments",
  "applied_kinesiology": "Applied Kinesiology",
  "neuro_feedback_therapy": "Neuro Feedback Therapy",
  "foot_bath": "Foot Bath",
  "hair_analysis": "Hair Analysis",
  "homeopathy": "Homeopathy",
  "braincore_therapy": "BrainCore Therapy",
  "interferential": "Interferential",
  "interpretation_of_diagnostic": "Interpretation of Diagnostic Blood Studies",
  "microcurrent": "Microcurrent",
  "spinal_decompression": "Spinal Decompression",
  "treatment_of_diagnosis": "Treatment of Diagnosis other than N.M.S",
  "urinalysis": "Urinalysis"
}


const handleDownload = () => {
  const link = document.createElement("a");
  link.href = `${API_URL}online-quotation-inquiry/images/Application.pdf`;
  link.download = "filename.pdf";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const InquiryPage: React.FC = () => {
  const [form] = Form.useForm();
  const [employee_types, setEmployeeTypes] = useState<string[]>([]);
  const [practice_states, setPracticeStates] = useState<PracticeState[]>([{name:"",abbreviation:""}]);
  const [practice_states_loading, setPracticeStatesLoading] = useState(false);
  const [policy_types, setPolicyTypes] = useState<string[]>([""]);
  const [policy_types_loading, setPolicyTypesLoading] = useState(false);
  const [companies, setCompanies] = useState<string[]>([""]);
  const [companies_loading, setCompaniesLoading] = useState(false);
  const [ll_requesteds, setllRequesteds] = useState<string[]>([""]);
  const [ll_requesteds_loading, setllRequestedsLoading] = useState(false);
  const [fromaddrs, setFromAddrs] = useState<string[]>([""]);
  const [fromaddrs_loading, setFromAddrsLoading] = useState(false);
  const [sel_practice_items, setSelectedPracticeItems] = useState<string[]>([]);
  const [aboutus_visible, setAboutUsVisible] = useState(false);
  const [is_mal_practice_claim, setMalPracticeClaim] = useState(false);

  const onSubmit = (inqueryRequest: InqueryRequest) => {
    console.log(inqueryRequest)
    api_quota_inquery(inqueryRequest)
      .then((InqueryResponse) => {
        if (InqueryResponse.success) {
          form.resetFields();
          notification.success({
            message: 'Submission Completed',
            description: 'Thanks for submitting your information, we will contact you soon.',
          });
        }
        else {
          message.error(InqueryResponse.msg)
        }
      })
      .catch((error) => {
        console.error("An error occurred:", error.message);
        return
      });
  };

  const onFinishFailed = (errorInfo: any) => {
    alert("Please check the form fields and try again.");
  };
  
  const onPracticeStates = async () => {
    console.log("onPracticeStates")
    setPracticeStatesLoading(true);
    api_practice_states()
      .then((practice_states) => {
        setPracticeStates(practice_states);
      })
      .catch((error) => {
        console.error("An error occurred:", error.message);
      })
      .finally(() => {
        setPracticeStatesLoading(false);
      });
  };

  const onPoilicyTypes = async () => {
    console.log("onPoilicyTypes")
    setPolicyTypesLoading(true);
    api_policy_type()
      .then((policy_types) => {
        setPolicyTypes(policy_types);
      })
      .catch((error) => {
        console.error("An error occurred:", error.message);
      })
      .finally(() => {
        setPolicyTypesLoading(false);
      });
  };

  const onCompanies = async () => {
    console.log("onCompanies")
    setCompaniesLoading(true);
    api_companies()
      .then((companies) => {
        setCompanies(companies);
      })
      .catch((error) => {
        console.error("An error occurred:", error.message);
      })
      .finally(() => {
        setCompaniesLoading(false);
      });
  }

  const onLLRequesteds = async () => {
    console.log("onLlRequesteds")
    setllRequestedsLoading(true);
    api_ll_requested()
      .then((ll_requesteds) => {
        setllRequesteds(ll_requesteds);
      })
      .catch((error) => {
        console.error("An error occurred:", error.message);
      })
      .finally(() => {
        setllRequestedsLoading(false);
      });
  }

  const onContactAboutUs = async () => {

    setFromAddrsLoading(true);
    api_get_from_addrs()
      .then((fromaddrs) => {
        setFromAddrs(fromaddrs);
      })
      .catch((error) => {
        console.error("An error occurred:", error.message);
      })
      .finally(() => {
        setFromAddrsLoading(false);
      });
  };


  useEffect(() => {
    api_get_employee_type()
      .then((employee_types) => {
        setEmployeeTypes(employee_types)
      })
      .catch((error) => {
        console.error("An error occurred:", error.message);
      })
      .finally(() => {
      });
  }, []);


  return (
    <div>
      <HeaderComponent />
      <div className='mt-10 max-w-screen-xl mx-auto p-20'>

        <div className='flex flex-col mb-10'>

          <Title level={2}>Online Quotation Inquiry</Title>
          <p>
            Our Online Quote Inquiry is a convenient way for you to secure a premium indication for your malpractice coverage with ChiroFutures.
            A bindable proposal and premium quotation can only be received after we receive your completed application.
            If you wish to save time by submitting an application now, please download an application and submit it to our office.
          </p>
          <a onClick={handleDownload}>
            <Image width={40} src="images/adobe-icon.png" alt="Sample" preview={false} />
            <span>Download application</span>
          </a>

        </div>

        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          onFinishFailed={onFinishFailed}
        >
          <Title level={4}>ChiroFutures</Title>
          <div className='mb-5 grid grid-cols-2 sm:grid-cols-6 gap-2'>
            <div className='col-span-2 sm:col-span-6'>
              <Title level={5}>Demographic Information</Title>
            </div>
            <div className='col-span-2 sm:col-span-6 lg:col-span-3'>
              <Form.Item label="First Name" name="first_name" rules={[{ required: true }]}>
                <Input placeholder="Please enter your First name" />
              </Form.Item>
            </div>
            <div className='col-span-2 sm:col-span-6 lg:col-span-3'>
              <Form.Item label="Last Name" name="last_name" rules={[{ required: true }]}>
                <Input placeholder="Please enter your Last name" />
              </Form.Item>
            </div>
            <div className='col-span-2 sm:col-span-6 lg:col-span-3'>
              <Form.Item label="License * (enter none if license is pending)" name="license_number" rules={[{ required: true }]}>
                <Input placeholder="Please enter your License number" />
              </Form.Item>
            </div>
            <div className='col-span-2 sm:col-span-6 lg:col-span-3'>
              <Form.Item label="Date first began practicing as a Chiropractor" name="date_first_licensed">
                <DatePicker placeholder="Please enter Date" style={{ width: "100%" }} />
              </Form.Item>
            </div>
            <div className='col-span-1 sm:col-span-3'>
              <Form.Item label="E-mail" name="email" rules={[{ type: "email", required: true }]}>
                <Input placeholder="Please enter your E-mail" />
              </Form.Item>
            </div>
            <div className='col-span-1 sm:col-span-3'>
              <Form.Item label="E-mail confirmation" name="emailConfirm" rules={[{ type: "email", required: true }]}>
                <Input placeholder="Please enter your E-mail" />
              </Form.Item>
            </div>

            <div className='col-span-2 sm:col-span-6 lg:col-span-3'>
              <Form.Item label="Practice address" name="practice_address" rules={[{ required: true }]}>
                <Input placeholder="Please enter your Practice address" />
              </Form.Item>
            </div>
            <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
              <Form.Item label="City" name="practice_city" rules={[{ required: true }]}>
                <Input placeholder="City" />
              </Form.Item>
            </div>
            <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
              <Form.Item label="State" name="practice_state" rules={[{ required: true }]}>
                <Select placeholder="State" onDropdownVisibleChange={onPracticeStates} loading={practice_states_loading}>
                  {practice_states.map((state) => (
                    <Select.Option key={state.abbreviation} value={state.abbreviation}>
                      {state.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div className='col-span-2 sm:col-span-2 lg:col-span-1'>
              <Form.Item label="ZIP Code" name="practice_zip_code" rules={[{ required: true }, { pattern: /^\d{5}(-\d{4})?$/, message: 'Use XXXXX or XXXXX-XXXX format please' }]}>
                <Input placeholder="ZIP code" />
              </Form.Item>
            </div>
            {/* <div className='col-span-2'>
              <Form.Item label="Telephone" name="telephone" rules={[{ required: true }, { pattern: /^\d{3}-\d{3}-\d{4}$/, message: 'Use XXX-XXX-XXXX format please' }]}>
                <Input placeholder="Please enter your Telephone" />
              </Form.Item>
            </div>             */}
            <div className='col-span-1 sm:col-span-3'>
              <Form.Item label="Cell Phone" name="cell_phone" rules={[{ required: true }, { pattern: /^\d{3}-\d{3}-\d{4}$/, message: 'Use XXX-XXX-XXXX format please' }]}>
                <Input placeholder="Please enter your Cell Phone" />
              </Form.Item>
            </div>
            <div className='col-span-1 sm:col-span-3'>
              <Form.Item label="Office Phone" name="office_phone" rules={[{ required: false }, { pattern: /^\d{3}-\d{3}-\d{4}$/, message: 'Use XXX-XXX-XXXX format please' }]}>
                <Input placeholder="Please enter your Office Phone" />
              </Form.Item>
            </div>
          </div>

          <div className='mb-5  grid grid-cols-1 lg:grid-cols-3 gap-2'>
            <div className='col-span-1 lg:col-span-3'>
              <Title level={5}>Policy Information</Title>
            </div>
            <div className='col-span-1'>
              <Form.Item   label="What kind of coverage do you currently have" name="policy_type" rules={[{ required: true }]} >
                <Select placeholder="Coverage" onDropdownVisibleChange={onPoilicyTypes} loading={policy_types_loading}>
                  {policy_types.map((type) => (
                    <Select.Option key={type} value={type}>
                      {type}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div className='col-span-1'>
              <Form.Item label="Current Insurance Company" name="insurance_company" rules={[{ required: true }]}>
                <Select placeholder="Insurance company" onDropdownVisibleChange={onCompanies} loading={companies_loading}>
                  {companies.map((company) => (
                    <Select.Option key={company} value={company}>
                      {company}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div className='col-span-1'>
              <Form.Item label="Limits of Liability Requested" name="ll_requested" rules={[{ required: true }]}>
                <Select placeholder="Limits of Liability" onDropdownVisibleChange={onLLRequesteds} loading={ll_requesteds_loading}>
                  {ll_requesteds.map((ll_requested) => (
                    <Select.Option key={ll_requested} value={ll_requested}>
                      {ll_requested}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div className='col-span-1 lg:col-span-3'>
              <Form.Item label="If Claims Made, what is the Retroactive/Prior Acts date?" name="retroactive_claims_made_date">
                <DatePicker placeholder="Acts date" style={{ width: "100%" }} />
              </Form.Item>
            </div>
            <div className='col-span-1 lg:col-span-3'>
              <Form.Item label="Current Policy Expiration Date" name="current_policy_expiration_date">
                <DatePicker placeholder="Expiration date" style={{ width: "100%" }} />
              </Form.Item>
            </div>
          </div>

          <div className='mb-3 grid grid-cols-5 gap-2'>
            <div className='col-span-5'>
              <Title level={5}>Clinical Practice Information</Title>
            </div>
            <div className='col-span-5'>
              <Form.Item label="How many total hours per week are you practicing? (includes time spent treating patients, noting charts and consulting, i.e. IME, Utilization Review, and Peer Review)?" name="practice_hours_per_week" rules={[{ required: true }]}>
                <Input placeholder="" type="number" />
              </Form.Item>
            </div>
            <div className='col-span-5'>
              <Form.Item label="Besides yourself, indicate the number of Healthcare Professionals who work in your office or with whom you share space" name="chiropractors_number" rules={[{ required: true }]}>
                <Input placeholder="" type="number" />
              </Form.Item>
            </div>
            <div className='col-span-5'>
              <Form.Item label="You will be working as:" name="employee_type" rules={[{ required: true }]}>
                <Radio.Group>
                  <div className='grid grid-cols-1 gap-4 mb-4'>
                    {employee_types.map((employee_type) => (
                      <Radio key={employee_type} value={employee_type}>{employee_type}</Radio>
                    ))}
                  </div>
                </Radio.Group>
              </Form.Item>
            </div>
            <div className='col-span-4'>
              <p>Have you attended a risk-management seminar in the last 24 months?</p>
            </div>
            <div className='col-span-1'>
              <Form.Item name="attended_risk_management" valuePropName="checked">
                <Checkbox>Yes</Checkbox>
              </Form.Item>
            </div>
            <div className='col-span-4'>
              <p>Do you have (or have you ever had) a malpractice claim or lawsuit filed, settled or currently open since you began practicing?</p>
            </div>
            <div className='col-span-1'>
              <Form.Item name="malpractice_claim" valuePropName="checked">
                <Checkbox onChange={(e) => (setMalPracticeClaim(e.target.checked))}>Yes</Checkbox>
              </Form.Item>
            </div>
            <div className='col-span-5'>
              <Form.Item label="Date of last claim" name="malpractice_claim_date" rules={[{ required: is_mal_practice_claim }]}>
                <DatePicker placeholder="" style={{ width: "100%" }} disabled={!is_mal_practice_claim} />
              </Form.Item>
            </div>
            <div className='col-span-4'>
              <p>Do you have (or have you ever had) any disciplinary action taken against your license in any state, including any currently open or pending investigation?</p>
            </div>
            <div className='col-span-1'>
              <Form.Item name="pending_investigation" valuePropName="checked">
                <Checkbox>Yes</Checkbox>
              </Form.Item>
            </div>
            <div className='col-span-4'>
              <p>Have you ever been convicted and/or have any open and pending misdemeanor or felony charges other than a traffic ticket?</p>
            </div>
            <div className='col-span-1'>
              <Form.Item name="convicted_felony" valuePropName="checked">
                <Checkbox>Yes</Checkbox>
              </Form.Item>
            </div>
            <div className='col-span-5'>
              <Form.Item label="Where did you hear about us?" name="contact_about_us" rules={[{ required: true }]}>
                <Select placeholder="" onDropdownVisibleChange={onContactAboutUs} loading={fromaddrs_loading}>
                  {fromaddrs.map((fromaddr) => (
                    <Option key={fromaddr} value={fromaddr}>
                      {fromaddr}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>

          </div>
          <div className='mb-10 grid grid-cols-1 sm:grid-cols-3 gap-1'>
            <div className='col-span-1 sm:col-span-3'>
              <p>Check each of the following items provided by you or someone employed by you in your practice:</p>
            </div>
            {Object.entries(practiceItems).map(([key, value]) => (
              <div className='col-span-1'>
                <Form.Item name={key} valuePropName="checked">
                  <Checkbox
                    key={value}
                    value={value}
                    onChange={(e) => {
                      const updatedList = e.target.checked
                        ? [...sel_practice_items, value]
                        : sel_practice_items.filter(s => s !== value);
                      setSelectedPracticeItems(updatedList);
                    }}
                  >
                    {value}
                  </Checkbox>
                </Form.Item>
              </div>
            ))}
          </div>

          <div className='grid grid-cols-1 gap-4'>
            <div className='col-span-1'>
              <Title level={4}>Disqualifying Practices...</Title>
            </div>
            <div className='col-span-1'>
              <p>The following procedures are outside the scope of our program: Colon Irrigation, Manipulation under Anesthesia, Iridology , the prescribing of drugs and invasive EMG. If any of these are part of your practice, or performed by others within your office, we will be unable to provide coverage. Thank you.</p>
            </div>
            <div className='col-span-1'>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button type="primary" htmlType="submit">Submit</Button>
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
}

export default InquiryPage;